export const environment = {
  serverUrl: 'https://api-delta-rom.rrsolutionstest.it/api/v1/frontend/',
  userSessionUniqueId: 'C332ABAA8154B',
};
